import apiConfig from "../config/api";
import { get, getAV2, post, put, put_av2, requestDelete, requestDelete_av2 } from "../helpers/request";

const autoasignApi = `${apiConfig.apiUri}api/accessmanagement/selfassignment`;
const autoasignApiAV2 = `${apiConfig.apiUriAV2}api/admin/v1/gestion-usuarios/usuarios/`;
const empresasApiAV2 = `${apiConfig.apiUriAV2}api/inicio/v1/empresa/listaEmpresa/`;
export const getAssignedCompanies = (params) => get(`${autoasignApi}/get`, { params });

export const getAllCompanies = (params) => get(`${autoasignApi}/get/companies`, { params });

export const assignCompany = (companies) =>
  post(`${autoasignApi}/create`, {
    body: JSON.stringify({
      CompanyRuts: companies,
    }),
  });

export const deleteCompany = (companies) =>
  requestDelete(`${autoasignApi}/delete`, {
    body: JSON.stringify({
      Assignments: companies,
    }),
  });
  
export const assignCompanyAV2 = (companies) => { // Debería ser posible agregar varias empresas al tiempo
  try{
    return put_av2(`${autoasignApiAV2}crear/rolautoasignado`, {
      body: JSON.stringify({
        entidad: companies,
        autoasignacionRol: 'TRABAJADOR_ACHS_AUTOASIGNADO'
      })
    })
  }catch(e){
    throw new Error()
  }
  
}
export const deleteCompanyAV2 = (companies) => {
  try{
    return requestDelete_av2(`${autoasignApiAV2}eliminar/autoasignado/empresa`, {
      body: JSON.stringify({
        entidad: companies
      })
    })
  }catch(e){
    throw new Error()
  }
  
}

export const validateCompanies = (ruts) => 
getAV2(`${empresasApiAV2}${ruts.join(',')}`)

export const validarRutsEmpresas = async (ruts) => {
  try{
    const response = await validateCompanies(ruts)
    const empresasValidas = await response.json()
    if(empresasValidas.statusCode === 404){
      return {rutsValidos: [], rutsNoValidos: ruts}
    }
    const rutsValidos = empresasValidas.filter(e => !e.estaDeshabilitado).map((j => j.rutEmpresa))
    const rutsNoValidos = ruts.filter(r => !rutsValidos.some(rv => rv === r))
    return {rutsValidos, rutsNoValidos}
  }catch(e){
    return {rutsValidos: [], rutsNoValidos: ruts}
  }
  
}

